import { useContext } from "react"

import { context } from "./EditorStore"
import { IEditorStoreContext } from "./types"

export const useEditorStore = () => {
  return useContext(context) as IEditorStoreContext
}
